import { useFormik } from "formik";
import FormField from "../Input/FormField";
import PageSection from "../Layout/PageSection";
import Button from "../Input/Button";
import { useState, useEffect, useContext  } from "react";
import Context from "../../../context";
import axios from "axios";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import StatementItem from "../Layout/StatementItem";

import PaymentMethodPageSection from "../Layout/PaymentMethodPageSection";
import { API_URL } from "../../data/constants";
import * as Icon from "react-bootstrap-icons";

function getSixtyDays(date) {
    let res = new Date(date);
    res.setDate(res.getDate() + 60);
    return res;
}
export default function PayMyBillPage() {
    const { contextState, setContextState } = useContext(Context);
    const [statementList, setStatementList] = useState([]);
    const [selectedMethod, setSelectedMethod] = useState();
    const [payDate, setPayDate] = useState(new Date());
    const [paymentSuccess, setPaymentSuccess] = useState();
    const [shouldShowMessage, setShouldShowMessage] = useState(false);
    const [message, setMessage] = useState();
    const [selectedItem, setSelectedItem] = useState();
    const [paymentAmount, setPaymentAmount] = useState();
    let account = contextState.currentAccount;

    useEffect(() => {
        axios
            .post(
                API_URL + "/Statements/Unpaid",
                {
                    fromDate: new Date(),
                    toDate: new Date(),
                    customerId: account?.contract?.customerId,
                    customerNumber: account?.customerNumber,
                    masterCustomerId: null,
                    userName: null,
                },
                {
                    headers: {
                        Authorization: `${localStorage.getItem("accessToken")}`,
                    },
                }
            )
            .then((res) => {
                setStatementList(res.data);
            })
            .catch((err) => {
                console.error(err);
            });
    }, [contextState.accounts]);

    useEffect(() => {
        let statements = statementList
            .filter((statement) => statement.isSelected === true)
            .map((statement) => {
                return {
                    balanceDue: statement.balanceRemaining
                };
            });
        let total = statements.reduce((n, {balanceDue}) => n + balanceDue, 0);
        if (total === 0) total = null;
        else total = total.toFixed(2);
       
        if (!paymentAmount){
            payBillForm.setFieldValue("paymentAmount",total);
            setPaymentAmount(total);
        }
        if (!total){
            payBillForm.setFieldValue("paymentAmount","");
            setPaymentAmount("");
        }
    }, [selectedItem]);

    useEffect(() => {
        let statements = statementList
            .filter((statement) => statement.isSelected === true);
        if(statements.length === 0){
            setSelectedItem(null);
        }
    }, [paymentAmount]);
    
    function validate(values) {
        const errors = {};
        //if (!values.paymentAmount) errors.paymentAmount = "Required";
        if (!paymentAmount) errors.paymentAmount = "Required";
        return errors;
    }
    
    const payBillForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            paymentAmount: "",
            paymentDate: "",
        },
        validate,
        onSubmit: (values) => {
            let statements = statementList
                .filter((statement) => statement.isSelected === true)
                .map((statement) => {
                    return {
                        invoiceNumber: statement.invoiceNumber,
                        statementId: statement.statementId,
                    };
                });

            let customerId = contextState.currentAccount.customer.customerId
     
            axios
                .post(
                    API_URL + "/Payments/Receive",
                    {
                        customerId: customerId,
                        customerNumber: account?.customerNumber,
                        masterCustomerId: null,
                        statements: statements,
                        totalAmount: paymentAmount,
                        paymentDate: payDate,
                        createdBy: localStorage.getItem("username"),
                        paymentMethodId: selectedMethod.isCard ? "9" : "10",
                        customerProfileId: selectedMethod.customerProfileId,
                        paymentProfileId: selectedMethod.paymentProfileId,
                    },
                    {
                        headers: {
                            Authorization: `${localStorage.getItem("accessToken")}`,
                        },
                    }
                )
                .then((res) => {
                    setPaymentSuccess(res.data.success);
                    setShouldShowMessage(true);
                    setMessage(res.data.message)
                    if (res.data.success){
                        axios
                            .post(
                                API_URL + "/Statements/Unpaid",
                                {
                                    fromDate: new Date(),
                                    toDate: new Date(),
                                    customerId: account?.contract?.customerId,
                                    customerNumber: account?.customerNumber,
                                    masterCustomerId: null,
                                    userName: null,
                                },
                                {
                                    headers: {
                                        Authorization: `${localStorage.getItem("accessToken")}`,
                                    },
                                }
                            )
                            .then((res) => {
                                setStatementList(res.data);
                            })
                            .catch((err) => {
                                console.error(err);
                            });   
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },
    });

    return (
        <div className="individual-wrapper">
            <div className="individual-header">
                <h1>Pay My Bill</h1>
            </div>
            <form onSubmit={payBillForm.handleSubmit}>
                <PaymentMethodPageSection
                    form={payBillForm}
                    hasExisting
                    title="Payment Methods"
                    paymentView="existing"
                    setSelectedMethod={setSelectedMethod}
                    noOptions
                />

                <PageSection sectionName="Select Unpaid Statements">
                    {statementList.length > 0 ? (
                        statementList.map((statement, index) => {
                            return (
                                <StatementItem key={index} statement={statement} hasCheckbox setSelectedItem={setSelectedItem}/>
                            );
                        })
                    ) : (
                        <h4 className="mx-auto">No existing unpaid statements.</h4>
                    )}
                </PageSection>
                <PageSection sectionName="Complete Payment" isForm>
                    <p className="page-section-warning mb-4 ml-0">
                        NOTE: Payments made with today's date are processed and posted immediately upon submitting the request.
                        Payments scheduled for a future date will process and post at 2:15 AM on the scheduled date.
                        Scheduled payments may be viewed or canceled on the transaction history page.
                        Payments made by bank draft take 2-3 business days to clear regardless of the date they are processed.
                        Bank draft payments that are returned will result in a $30.00 return check fee being assessed to your account.
                    </p>
                    <div className="form-row mb-4">
                        <div className="col-lg-6">
                            {/*<FormField
                                name="Payment Amount"
                                field="paymentAmount"
                                type="text"
                                onChange={(paymentAmount) => setPaymentAmount(paymentAmount)}
                                form={payBillForm}
                            />*/}
                            <label className="form-label">Payment Amount</label><br />
                            <input
                                className="form-control"
                                id="paymentAmount"
                                type="text"
                                name="paymentAmount"
                                value={paymentAmount}
                                onChange={e => setPaymentAmount(e.target.value)}
                                onKeyPress={(event) => {
                                    if (!/[0-9,.]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                        </div>
                        <div className="col-lg-6">
                            <label className="form-label">Payment Date</label>
                            <DatePicker
                                selected={payDate}
                                onChange={(date) => setPayDate(date)}
                                maxDate={getSixtyDays(new Date())}
                            />
                        </div>
                    </div>
                    <Button
                        className="btn btn--green btn--bordered mb-4"
                        text="Process Payment"
                        type="submit"
                        disabled={
                            /*!(payBillForm.dirty && payBillForm.isValid) ||*/
                            !paymentAmount || !selectedItem || !payDate ||
                            selectedMethod === null ||
                            selectedMethod === undefined ||
                            account?.shutoffToAglOn
                        }
                    />
                    {account?.shutoffToAglOn && (
                        <p className="page-section-warning mb-4 ml-0">
                            This account has been shut off, so please call NextEra Energy Services to make a payment (678) 872-0250.
                        </p>
                    )}
                    {shouldShowMessage && (
                        <>
                            {paymentSuccess === true ? (
                                <div className="alert alert-success">
                                    <div className="d-flex justify-content-between">
                                        {message}
                                        <Icon.X
                                            onClick={() => setShouldShowMessage(false)}
                                            size={24}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className="alert alert-danger justify-content-between">
                                    <div className="d-flex justify-content-between">
                                        {message}
                                        <Icon.X
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setShouldShowMessage(false)}
                                            size={24}
                                        />
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </PageSection>
            </form>
        </div>
    );
}
